import { Metamodel } from 'app/model/base/model';
import { AzureMySqlTableDataset } from 'app/model/dataset/azure-mysql-table.dataset';
import { IntegerDataFlowType, StringDataFlowType } from '../dataflow-datatype';
import { DataFlowSource, IsolationLevel } from '../dataflow-source';
import { DataFlowExpression } from '../dataflowexpression';
import { DatasetFormatType } from './dataflow-dataset-settings';
import { TabularTypeSettings } from './tabular-type-settings';
import { adfModelTypeMap } from '../../../registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.azureMySql.dataflowSettings
})
export class MysqlSettings extends TabularTypeSettings {
    public isolationLevel: DataFlowExpression;
    public isPreSqlsListOfExpression: boolean;
    public preSqls: DataFlowExpression[];
    public isPostSqlsListOfExpression: boolean;
    public postSqls: DataFlowExpression[];

    public supportDataFlowStoreProcedure: boolean = true;

    @Metamodel.attribute({
        constraint: {
            validator: DataFlowSource.validateBatchSize
        }
    })
    public batchSize: DataFlowExpression;

    public initialize(subFormat: string): void {
        super.initialize(subFormat);
        this.isolationLevel = this.transform.createTemplatableExpression(StringDataFlowType.TYPE, IsolationLevel.ReadUncommitted);
        this.batchSize = this.transform.createTemplatableExpression(IntegerDataFlowType.TYPE);
        this.isPreSqlsListOfExpression = true;
        this.isPostSqlsListOfExpression = true;
        this.preSqls = [this.transform.createTemplatableExpression()];
        this.postSqls = [this.transform.createTemplatableExpression()];
    }

    public getFormat(): DatasetFormatType {
        return DatasetFormatType.Mysql;
    }

    public getSubFormat(): string {
        return undefined;
    }

    public getDatasetType(): string {
        return Metamodel.modelFor(AzureMySqlTableDataset).name;
    }

    public getIconClass(): string {
        return 'i-100x100-azure_database_for_mysql';
    }
}
